<template>
  <div class="font-14 color-fff top-section-wrap" style="min-height: 250px">
    <div class="wrap-grey" style="min-height: 250px">
      <div class="d-flex justify-center align-center top-section-title" style="min-height: 250px">
        <!-- The title is not the same as in the Adobe XD-->
        <span>{{ $t('about.title') }}</span>
      </div>

      <!--<div class="top-section-desc">
        <span>{{ $t('about.desc') }}</span>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Title',
  components: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {}
};
</script>

<style lang="stylus" scoped>
.top-section-wrap {
  background: url('../../assets/images/about-bg.png') no-repeat fixed center -630px;
  text-align: center;

  .wrap-grey {
    width: 100%;
    height: 100%;
    background-color: rgba(37, 40, 52, 0.5);

    .top-section-title {
      font-size: 30px;
      /*padding: 50px 15px 0;*/
    }

    .top-section-desc {
      padding: 30px 10px 90px;
      margin: 0 auto;
      max-width: 508px;
    }
  }
}
</style>
